import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/pedido'

class GestaoPedidoApiClient {
	async criarNovoPedido(objParam) {
		return await axios.post(`${URL_PATH}/rascunho`, objParam)
	}

	async buscarListagemDePedidosPorProcesso(objParam, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/porProcesso`,
			filters: objParam,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async buscarListagemPedidosCollapse(objParam, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/processo/numero`,
			filters: objParam,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(url)
	}
}

export default new GestaoPedidoApiClient()
